import { memo } from 'react'

export default memo(function ProjectBook() {
  return <div>ProjectBook</div>
})
